// import profile images
import ProfilePhoto1 from "../src/assets/img/profile1.png";
import ProfilePhoto2 from "../src/assets/img/profile2.png";
import ProfilePhoto3 from "../src/assets/img/profile3.png";

// import about icons
import Skill1 from "../src/assets/img/skills/skill1.png";
import Skill2 from "../src/assets/img/skills/skill2.png";
import Skill3 from "../src/assets/img/skills/skill3.png";
import Skill4 from "../src/assets/img/skills/skill4.png";
import Skill5 from "../src/assets/img/skills/skill5.png";
import Skill6 from "../src/assets/img/skills/skill6.png";

// import team images
import TeamMember1 from "../src/assets/img/lawyer4.png";

// import social icons
import FacebookIcon from "../src/assets/img/social/facebook.png";
import TwitterIcon from "../src/assets/img/social/twitter.png";
import InstagramIcon from "../src/assets/img/social/instagram.png";
import YoutubeIcon from "../src/assets/img/social/youtube.png";
import PinterestIcon from "../src/assets/img/social/pinterest.png";

// navigation data
export const navigation = [
  {
    name: "About",
    href: "about",
  },
  {
    name: "Home",
    href: "home",
  },

  // {
  //   name: "Reviews",
  //   href: "review",
  // },

  {
    name: "Services",
    href: "service",
  },
  {
    name: "Your team",
    href: "team",
  },
  // {
  //   name: "Schedule a Consultation",
  //   href: "consultation",
  // },
];

// testimonials data
export const testimonials = [
  {
    text: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Dolorem rem ad consequuntur similique sequi illum dolorum omnis inventore labore odio!",
    name: "Jane Cooper",
    image: ProfilePhoto1,
    position: "Web Developer",
  },
  {
    text: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Dolorem rem ad consequuntur similique sequi illum dolorum omnis inventore labore odio!",
    name: "Theresa Webb",
    image: ProfilePhoto2,
    position: "Web Designer",
  },
  {
    text: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Dolorem rem ad consequuntur similique sequi illum dolorum omnis inventore labore odio!",
    name: "Kathryn Murphy",
    image: ProfilePhoto3,
    position: "UI/UX Designer",
  },
];

// skills data
export const skills = [
  {
    icon: Skill1,
    title: "Corruption",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed erat nibh tristique ipsum.",
  },
  {
    icon: Skill2,
    title: "Employment",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed erat nibh tristique ipsum.",
  },
  {
    icon: Skill3,
    title: "Real Estate",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed erat nibh tristique ipsum.",
  },
  {
    icon: Skill4,
    title: "Taxes",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed erat nibh tristique ipsum.",
  },
  {
    icon: Skill5,
    title: "Corporate",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed erat nibh tristique ipsum.",
  },
  {
    icon: Skill6,
    title: "Banking",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed erat nibh tristique ipsum.",
  },
];

// team data
export const team = [
  {
    image: TeamMember1,
    name: "Chinazo Chi-Chi Louis",
    position: "Lawyer",
    description:
      "Cire Legal is led by Attorney Chinazo “Chi Chi” Louis. She is a dedicated advocate committed to helping clients protect their brands, businesses, and futures with clarity and confidence.",
  },
];

// social data
export const social = [
  {
    icon: FacebookIcon,
  },
  {
    icon: TwitterIcon,
  },
  {
    icon: InstagramIcon,
  },
  {
    icon: YoutubeIcon,
  },
  {
    icon: PinterestIcon,
  },
];
